import { Button, CardMedia, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'

import { billConfirmed, billOrdered } from '~/assets/images'
import BannerPromote from '~/components/BannerPromote'
import BottomAppInfo from '~/components/BottomAppInfo'
import { keywordScreen, marginX } from '~/constants'
import { selectRestaurant } from '~/redux/restaurantSlice'
import { path } from '~/routes/path'

// Màn hình dùng chung nhiều chỗ
const ConfirmedPayment = () => {
  const { t } = useTranslation()
  const { keyword } = useParams()
  const navigate = useNavigate()
  const { capichi_delivery_following, banner_promote_delivery } = useSelector(selectRestaurant)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const isOrdering = keyword === keywordScreen.ordering

  const renderImageBill = () => {
    const uriImage = isOrdering ? billOrdered : billConfirmed
    const marginLeftImage = isOrdering ? '50px' : '0px'

    const widthImage =
      !banner_promote_delivery || banner_promote_delivery?.length === 0 ? '100%' : '60%'

    return (
      <Box display="flex" justifyContent="center">
        <CardMedia
          loading="lazy"
          component="img"
          image={uriImage}
          alt="bill"
          sx={{ width: widthImage, marginLeft: marginLeftImage, marginTop: '30px' }}
        />
      </Box>
    )
  }

  const renderTitle = () => {
    const title = isOrdering ? t('titles.order_success') : t('titles.payment_success')
    return (
      <Typography
        marginTop="20px"
        fontWeight="700"
        component="h2"
        fontSize="3.2rem"
        lineHeight="4rem"
        color={'baseColor.colorText1'}>
        {title}
      </Typography>
    )
  }

  const renderDescription = () => {
    const description = isOrdering
      ? t('descriptions.order_success')
      : t('descriptions.payment_success')
    return (
      <Typography
        marginBottom="10px"
        fontWeight="700"
        fontSize="1.4rem"
        lineHeight="1.8rem"
        width="85%"
        color={'baseColor.colorText1'}>
        {description}
      </Typography>
    )
  }

  const goBackMenuHandler = () => {
    navigate(path.indexMenu)
  }

  const renderButtonMenu = () => {
    if (!isOrdering) return null
    return (
      <Button onClick={goBackMenuHandler} sx={styles.btnDiscover}>
        {t('actions.back_to_menu')}
      </Button>
    )
  }

  const renderBannerPromote = () => {
    return <BannerPromote banner_promote_delivery={banner_promote_delivery} />
  }

  const renderBorderBottom = () => {
    if (!banner_promote_delivery || banner_promote_delivery?.length === 0) return
    return <Box borderBottom="solid 1px #000" marginTop="26px" />
  }

  return (
    <Box marginX={`${marginX}px`} paddingTop="10%" bgcolor="baseColor.color1" minHeight="100vh">
      <Box>
        {renderTitle()}
        {renderDescription()}
        {renderButtonMenu()}
      </Box>
      {renderImageBill()}
      {renderBorderBottom()}
      {renderBannerPromote()}
      {capichi_delivery_following ? <BottomAppInfo /> : null}
    </Box>
  )
}

export default React.memo(ConfirmedPayment)

const styles = {
  btnDiscover: {
    fontSize: '1.6rem',
    lineHeight: '2rem',
    padding: '10px 16px',
    alignItems: 'center',
    display: 'flex',
    backgroundColor: 'baseColor.colorText1',
    color: 'baseColor.colorText2',
  },
}
